import React from 'react';
import {
  Button,
  ModalFooter,
  Modal,
  ModalHeader,
  ModalSection,
  Dropdown,
  Form,
  ToastUtil,
  CondensedHeader,
  CondensedMedium,
  FluidButtonLayout,
} from '@axiom/ui';
import type { SelfServiceHelpRequired } from '@axiom/const';
import { selfServiceHelpRequiredValues } from '@axiom/const';
import type { AfcSubmission, SelfServiceHelpRequest } from '@axiom/validation';
import { SelfServiceHelpRequestSchema } from '@axiom/validation';

import { SelfServiceApi } from '../../api/self-service-api';

export type EngagementHelpModalProps = {
  currentSubmission: AfcSubmission;
  onClose: () => void;
};

export const EngagementHelpModal = ({
  currentSubmission,
  onClose,
}: EngagementHelpModalProps) => {
  const handleSubmit = async (data: SelfServiceHelpRequest) => {
    const body = {
      submissionId: currentSubmission.submissionId,
      helpRequired: data.helpRequired as SelfServiceHelpRequired,
    };

    await SelfServiceApi.createHelpRequest(body);
    ToastUtil.add({
      dismissible: 5,
      name: 'help-request-toast',
      type: 'info',
      children: (
        <>
          <CondensedHeader>Help is on the way!</CondensedHeader>
          <CondensedMedium>
            We'll reach out within 1 business day or sooner.
          </CondensedMedium>
        </>
      ),
    });
    onClose();
  };

  return (
    <Form
      name="engagement-help-form"
      schema={SelfServiceHelpRequestSchema}
      onSubmit={async data => {
        // @ts-expect-error Need type fix wtih APCORE-2687
        return handleSubmit(data);
      }}
      initialValues={{}}
    >
      {({ fireSubmit }) => {
        return (
          <Modal size="confirm" name="ENGAGEMENT_HELP_MODAL">
            <ModalHeader
              onClose={() => {
                onClose();
              }}
              name="ENGAGEMENT_HELP_MODAL_HEADER"
            >
              Send a request to get help fast
            </ModalHeader>
            <ModalSection disableScrolling>
              <Dropdown
                name="helpRequired"
                description="Choose the area that best describes what you need assistance with and we'll reach out within 1 business day - often sooner!"
                label="How can we help"
                options={Object.keys(selfServiceHelpRequiredValues).map(
                  key => ({
                    label:
                      selfServiceHelpRequiredValues[
                        key as keyof typeof selfServiceHelpRequiredValues
                      ],
                    value: key,
                  })
                )}
                displayKey="label"
                valueKey="value"
              />
            </ModalSection>
            <ModalFooter>
              <FluidButtonLayout stackableOn="mobile">
                <Button
                  name="help-modal-cancel-button"
                  pattern="primary"
                  variation="outline"
                  onClick={() => {
                    onClose();
                  }}
                >
                  Cancel
                </Button>
                <Button name="help-modal-submit-button" onClick={fireSubmit}>
                  Send Request
                </Button>
              </FluidButtonLayout>
            </ModalFooter>
          </Modal>
        );
      }}
    </Form>
  );
};
